module.exports = "/_next/static/images/bee935f9f19c08dd445820b11c694bae-card-circle.svg.webp";